import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Alerts from '../Alerts/Alerts';
import { LoadingAlert } from '../LoadingView/LoadingView';
import Spinner from '../../../../CommonComponents/Spinner';
import {
  isArchivingAlertSelector,
  isFetchingActiveAlertsSelector,
  isFetchingMoreActiveAlertsSelector,
} from '../../../ExperianSelector';
import { getActiveAlerts } from '../../../ExperianActions';
import { hasMoreActiveAlertsSelector } from '../../ReportsSelector';
import { Card, CardHeader, Content, Title, ShowMoreButton } from '../Alerts/AlertsStyles';
import ExperianContext from '../../../ExperianContext';

const ActiveAlerts = ({ alerts }) => {
  const isArchivingAlert = useSelector(isArchivingAlertSelector);
  const isFetchingActiveAlerts = useSelector(isFetchingActiveAlertsSelector);
  const isFetchingMoreActiveAlerts = useSelector(isFetchingMoreActiveAlertsSelector);
  const hasMoreActiveAlerts = useSelector(hasMoreActiveAlertsSelector);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <>
      <Card>
        {isArchivingAlert && <Spinner />}

        <CardHeader>
          <Title>Alerts</Title>
        </CardHeader>

        <Content>
          {isFetchingActiveAlerts ? (
            <>
              <LoadingAlert />
              <LoadingAlert />
              <LoadingAlert />
              <LoadingAlert />
              <LoadingAlert />
            </>
          ) : (
            <Alerts alerts={alerts} />
          )}
          {isFetchingMoreActiveAlerts && <LoadingAlert />}
        </Content>
      </Card>

      {hasMoreActiveAlerts && !isFetchingMoreActiveAlerts && (
        <ShowMoreButton
          onClick={() =>
            dispatch(getActiveAlerts(clientId, subscriberId, alerts[alerts.length - 1].AlertId))
          }
          disabled={isFetchingMoreActiveAlerts}
        >
          See more alerts
        </ShowMoreButton>
      )}
    </>
  );
};

ActiveAlerts.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      AlertId: PropTypes.string,
    }),
  ).isRequired,
};

export default ActiveAlerts;
